export const DEFAULT_INVALID_COLUMN_ERR =
  'One or more columns used in this widget are not available in the data source.';

export const defaultDroppingFeaturesAlertProps = {
  body: 'Data for this widget is not available at this zoom level. Zoom in to get data from features in the map.'
}
